export default {
	seller: 'Obchodník',
	failure: 'Neúspěch',
	formSubheader: 'Statistika',
	fulfilledInTime: 'Splněno v termínu',
	fulfilledInTimeOrWarning: 'Splněno v termínu / Po upozornění',
	fulfilledLate: 'Splněno po termínu',
	header: 'Statistika úkolů',
	notFulfilled: 'Nesplněno',
	openedAfterDeadline: 'Otevřené po termínu',
	openedBeforeDeadline: 'Otevřené v termínu',
	openedAfterWarning: 'Otevřené v termínu / Po upozornění',
	statsFrom: 'Období statistiky od',
	statsTo: 'Období statistiky do',
	statType: 'Typ statistiky',
	success: 'Úspěch',
	taskType: 'Typ úkolu',
	typeError: 'Povinný údaj Typ statistiky nebyl vyplněn',
	typeStatus: 'Dle stavu',
	typeSuccess: 'Dle úspěšnosti',
	dateFrom: 'Datum od',
	datesReversed: 'Hodnota „od“ musí být menší nebo rovna hodnotě „do“.',
};
